module.exports = __webpack_public_path__ + "img/hide.372a1587.svg";